// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3KXkW","actionsCol":"EnrolledClinics_actionsCol__82Sm3"};